module.exports = __webpack_public_path__ + "img/word-bg9.3955fb30.png";